var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22,
    r: 22,
    fill: "#04B776",
    fillOpacity: 0.23
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5508 16H19.5C20.6046 16 21.5 16.8954 21.5 18C21.5 19.1046 20.6046 20 19.5 20H17.5V21H19.5C20.6046 21 21.5 21.8954 21.5 23C21.5 24.1046 20.6046 25 19.5 25H17.5V26H19.5C20.6046 26 21.5 26.8954 21.5 28C21.5 29.1046 20.6046 30 19.5 30H17.7925C17.8687 30.1568 17.9647 30.2931 18.0858 30.4142C18.6716 31 19.6144 31 21.5 31H26.5C28.3857 31 29.3285 31 29.9143 30.4142C30.5 29.8284 30.5 28.8856 30.5 27V18C30.5 16.1144 30.5 15.1716 29.9143 14.5858C29.3285 14 28.3857 14 26.5 14H21.5C19.6144 14 18.6716 14 18.0858 14.5858C17.7592 14.9124 17.6147 15.3499 17.5508 16ZM26.5 21C25.9477 21 25.5 20.5523 25.5 20V18C25.5 17.4477 25.9477 17 26.5 17C27.0523 17 27.5 17.4477 27.5 18V20C27.5 20.5523 27.0523 21 26.5 21ZM15.5 17C14.9477 17 14.5 17.4477 14.5 18C14.5 18.5523 14.9477 19 15.5 19H19.5C20.0523 19 20.5 18.5523 20.5 18C20.5 17.4477 20.0523 17 19.5 17H15.5ZM15.5 22C14.9477 22 14.5 22.4477 14.5 23C14.5 23.5523 14.9477 24 15.5 24H19.5C20.0523 24 20.5 23.5523 20.5 23C20.5 22.4477 20.0523 22 19.5 22H15.5ZM15.5 27C14.9477 27 14.5 27.4477 14.5 28C14.5 28.5523 14.9477 29 15.5 29H19.5C20.0523 29 20.5 28.5523 20.5 28C20.5 27.4477 20.0523 27 19.5 27H15.5Z",
    fill: "#04B776"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.4d3c1baf94889d6b0cdc27851c0643d6.svg";
export { ForwardRef as ReactComponent };